import { render, staticRenderFns } from "./SlideSeniority.vue?vue&type=template&id=727cc7be&scoped=true&"
import script from "./SlideSeniority.vue?vue&type=script&lang=js&"
export * from "./SlideSeniority.vue?vue&type=script&lang=js&"
import style0 from "./SlideSeniority.vue?vue&type=style&index=0&id=727cc7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727cc7be",
  null
  
)

export default component.exports